export enum PlayLeaveSoundState {
  notPlay = -1,
  default = 0,
  play = 1,
  reloadAndPlay = 2,
}
